var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoyn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 40,
    className: "UserLogo variant-- ",
    viewBox: "0 0 200 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Joyn logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--userLogoColor, #000)",
    fillRule: "evenodd",
    d: "M92.112 20.45c0-2.45-1.662-4.287-4.024-4.287-2.363 0-4.026 1.837-4.026 4.287s1.663 4.287 4.025 4.287c2.363 0 4.025-1.837 4.025-4.287zm5.425 0c0 5.21-4.239 9.45-9.45 9.45-5.21 0-9.45-4.24-9.45-9.45 0-5.21 4.24-9.45 9.45-9.45 5.211 0 9.45 4.24 9.45 9.45zM67 11.525v5.162h4.638v14.175c0 1.576-.875 2.976-2.625 2.976H67V39h2.013c4.724 0 8.05-3.719 8.05-8.269V11.525H67zM127.463 11c-1.574 0-3.302.442-4.55 1.99v-1.465h-5.425v17.85h5.424v-10.15c0-1.662.875-3.062 2.617-3.062 1.758 0 2.633 1.4 2.633 2.975v10.237h5.426V18c0-4.462-2.45-7-6.125-7zm-17.676.525h5.426v19.206c0 4.55-3.325 8.269-8.05 8.269-4.638 0-8.05-3.675-8.05-7.7h5.424c.088 1.4 1.138 2.537 2.625 2.537 1.75 0 2.625-1.4 2.625-2.975V27.91c-1.248 1.548-2.976 1.99-4.55 1.99-3.675 0-6.125-2.538-6.125-7V11.525h5.425v10.238c0 1.574.875 2.974 2.634 2.974 1.741 0 2.616-1.4 2.616-3.062v-10.15z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoyn);
export default __webpack_public_path__ + "static/media/joyn.c50897c6ab0f3b7ee4774732b8709d3b.svg";
export { ForwardRef as ReactComponent };